import { z } from "zod";

export const payerSchema = z.object({
  id: z.string().uuid(),
  shortId: z.string(),
  createdAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable(),
  updatedAt: z.string().datetime().nullable(),
  stediId: z.string().nullable(),
  primaryPayerId: z.string().nullable(),
  name: z.string(),
  otherName: z.array(z.string()).nullable(),
  aliases: z.array(z.string()).nullable(),
  coverageTypes: z.array(z.string()).nullable(),
});

export type Payer = z.infer<typeof payerSchema>;

export const payerSearchResultSchema = z.object({
  shortId: z.string(),
  name: z.string(),
});

export type PayerSearchResult = z.infer<typeof payerSearchResultSchema>;

export const payerShape: Payer = {
  id: "",
  shortId: "",
  createdAt: "",
  deletedAt: null,
  updatedAt: "",
  stediId: null,
  primaryPayerId: null,
  name: "",
  otherName: null,
  aliases: null,
  coverageTypes: null,
};

export const getPayerDisplayName = (payer: Payer) => {
  const name = payer.name || "";

  return `${payer.primaryPayerId ?? payer.shortId} - ${name}`;
};
